import { Box } from 'braid-design-system';
import React, { type CSSProperties } from 'react';

import * as styles from './index.css';

interface Props {
  style: CSSProperties;
  testId?: string;
}

export const Indicator = ({ style, testId }: Props) => (
  <Box
    position="absolute"
    zIndex={1}
    className={styles.root}
    style={style}
    data-testid={testId}
  />
);
